<script>
export default {
    name: "login-window"
}
</script>

<template>
    <div class="login-window">
        <slot />
    </div>
</template>

<style scoped>
    .login-window {
        margin-top: 80px;
        padding: 32px 100px;
        width: 600px;
        border: 5px solid var(--color-easescreen-primary);
        border-radius: 10px;
        background-color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
</style>
